export default __webpack_public_path__ + "static/media/queenstown.30f910f6.jpg";